import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-input-information",
	templateUrl: "./input-information.component.html",
	styleUrls: ["./input-information.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputInformationComponent {
	@HostBinding("class.obg-input-information") hostCssClass = true;

	@Input() informationMessage: string | undefined;
	@Input() testId: string | undefined;
}
